export const DEFAULT_PAGE_OPTIONS = [5, 10, 25, 100, 500];
